/**
 * A URL aponta para um setor que o servidor conhece?
 *
 * Regra separada do componente porque as três condições que a compõem são
 * fáceis de escrever ao contrário, e errar qualquer uma produz um sintoma
 * ruim e silencioso:
 *
 * - ignorar `carregando` faz piscar "este setor não existe" para um setor
 *   perfeitamente legítimo, no meio do carregamento normal da lista;
 * - ignorar `fonteEhServidor` quebra a bancada, onde não há organização dona
 *   de nada e qualquer id sempre foi navegável;
 * - ignorar a checagem inteira devolve o beco sem saída que motivou isto: a
 *   página monta pela metade com widgets de cache, toda rota com guarda
 *   responde 404, e não há nada na interface que explique nem que ofereça
 *   saída.
 */
export interface EntradaDoSetorConhecido {
  /** `false` na bancada: a lista vem do `localStorage`, não do servidor. */
  fonteEhServidor: boolean;
  /** A lista de setores ainda está sendo buscada. */
  carregando: boolean;
  /** Ids que o servidor reconhece como da organização de quem pede. */
  conhecidos: readonly string[];
  /** O id que veio da URL. */
  alvo: string;
}

export function setorEhConhecido({
  fonteEhServidor,
  carregando,
  conhecidos,
  alvo,
}: EntradaDoSetorConhecido): boolean {
  if (!fonteEhServidor) return true;
  if (carregando) return true;
  return conhecidos.includes(alvo);
}
